import React from 'react'
import * as Yup from 'yup'

import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'

const initialValues = {
  email: '',
}

interface Props {
  errors?: string[] | string
  onSubmit: (e: any) => void
  loading?: boolean
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required('Required'),
})

export const ResetPasswordForm = ({
  errors = [],
  onSubmit = () => null,
  loading = false,
}: Props) => {
  return (
    <Form
      errors={errors}
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      loading={loading}
      submitCopy='Get reset link'
    >
      {() => (
        <>
          <Field name='email' placeholder='Enter email' />
        </>
      )}
    </Form>
  )
}
